/* istanbul ignore file */
import { useSession } from '@packages/utilities';
import { useIntl } from 'react-intl';
import useSWRImmutable from 'swr/immutable';
import useSWRMutation from 'swr/mutation';

// TODO(api-layer): needs to be reworked when wishlist resovler are implemented!

const skusFetcher = ([url, token]: Array<string>): Promise<{
  wishlist: Array<string>;
  size: number;
}> =>
  fetch(url, { headers: { 'x-ec-token': token } }).then((res) => {
    if (!res.ok) {
      throw new Error(`Get skus from wishlist error: Status ${res.status}: ${res.statusText}`);
    }
    return res.json();
  });

const addToWishlist =
  (locale: string) =>
  ([url, sku, unspecified, token]: [string, string, boolean, string]): Promise<{
    size: number;
    success: boolean;
    errorMessage?: string;
  }> =>
    fetch(url, {
      method: 'PUT',
      headers: {
        'x-ec-token': token,
        'ec-locale': locale,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sku, unspecified }),
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`Add to wishlist error: Status ${res.status}: ${res.statusText}`);
      }
      return res.json();
    });

const deleteFromWishlist =
  (locale: string) =>
  ([url, token]: Array<string>): Promise<{
    skus: Array<string>;
    success: boolean;
  }> =>
    fetch(url, {
      method: 'DELETE',
      headers: {
        'x-ec-token': token,
        'ec-locale': locale,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`Delete from wishlist error: Status ${res.status}: ${res.statusText}`);
      }
      return res.json();
    });

export const useWishlist = (sku: string, unspecified: boolean) => {
  const { locale } = useIntl();
  const { jwtToken } = useSession();

  const { trigger: triggerAddToWishlist } = useSWRMutation(
    jwtToken ? ['/api/wishlist/v1/', sku, unspecified, jwtToken] : null,
    addToWishlist(locale),
  );
  const { trigger: triggerDeleteFromWishlist } = useSWRMutation(
    jwtToken ? [`/api/wishlist/v1/${sku}`, jwtToken] : null,
    deleteFromWishlist(locale),
  );
  const {
    data,
    mutate: revalidateWishlist,
    isLoading,
  } = useSWRImmutable(jwtToken ? ['/api/wishlist/v1/skus', jwtToken] : null, skusFetcher);

  return { triggerAddToWishlist, triggerDeleteFromWishlist, revalidateWishlist, data, isLoading };
};
